module.exports = __webpack_public_path__ + "img/accessory_item_18.2908997c.svg";